import {KlassDropdown} from "components"
import CampusSelect from "components/CampusSelect"
import ProgramSelect from "components/ProgramSelect"
import StaffSelect from "components/StaffSelect"
import {UserOptionLabel} from "components/UserSelect/UserSelect"
import UserSelectV3 from "components/UserSelectV3"
import {useAdvisors} from "hooks"
import {useMemo} from "react"
import {Auth} from "types/auth"
import {AppliedFilter, FieldType, FilterKey} from "types/filter"
import {CallLogStatusOptions, InboundOutboundOptions} from "types/student-call-log"
import {FilterField, KlassappFilters} from "uiKit"

type Props = {
    departmentId: number
    filterKey?: FilterKey
    onApplyFilter: (payload: AppliedFilter) => void
    initialFilter?: AppliedFilter
    onClearFilter: () => void
}

export function StudentCallLogFilter(props: Props) {
    const {departmentId, filterKey, initialFilter, onApplyFilter, onClearFilter} = props
    const {admissionAdvisors} = useAdvisors().data || {}

    const availableFilters = useMemo(() => {
        let filters: FilterField[] = [
            {
                field: "staffs",
                label: "Staffs",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <StaffSelect departmentId={departmentId} isMulti placeholder="Staffs" {...props} />
                }
            },
            {
                field: "students",
                label: "Students",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return (
                        <UserSelectV3
                            type={[Auth.UserProfileType.Student]}
                            belongsToMyCampuses={false}
                            isMulti
                            placeholder="Students"
                            {...props}
                        />
                    )
                }
            },
            {
                field: "direction",
                label: "Inbound/Outbound",
                type: FieldType.Single,
                renderForm: (props: any) => {
                    return <KlassDropdown options={InboundOutboundOptions} placeholder="Inbound/Outbound" {...props} />
                }
            },
            {
                field: "status",
                label: "Call Status",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <KlassDropdown options={CallLogStatusOptions} isMulti placeholder="Call Status" {...props} />
                }
            },
            {
                field: "program",
                label: "Program",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <ProgramSelect isMulti placeholder="Program" {...props} />
                }
            },
            {
                field: "campus",
                label: "Campus",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return <CampusSelect isMulti placeholder="Campus" {...props} />
                }
            },
            {
                field: "admAdvisors",
                label: "Admissions Advisors",
                type: FieldType.List,
                renderForm: (props: any) => {
                    return (
                        <KlassDropdown
                            isMulti
                            options={admissionAdvisors}
                            valueKey="profileId"
                            labelKey="fullName"
                            getOptionLabel={UserOptionLabel}
                            placeholder="Admissions Advisors"
                            {...props}
                        />
                    )
                }
            },
            {
                field: "createdAtRange",
                label: "Logged Date",
                type: FieldType.Date
            }
        ]

        return filters
    }, [admissionAdvisors, departmentId])

    return (
        <KlassappFilters
            filterKey={filterKey}
            availableFilters={availableFilters}
            initialFilter={initialFilter}
            onApply={onApplyFilter}
            onClear={onClearFilter}
        />
    )
}
